/**
 * Aprende home — artículos del blog con custom.aprender = true vía Storefront API.
 * Imagen: custom.imagen_card_aprender | Badge: custom.categorias_aprender | Título: article.title
 */
(function () {
  'use strict';

  var GREEN_900 = '#0d4d27';
  var BLACK_BRAND = '#0e1c17';

  var CATEGORIA_APRENDER = {
    'bienestar-corporal': {
      label: 'Bienestar corporal',
      bg: '#AD99E3',
      fg: GREEN_900
    },
    'hogar-y-espacios': {
      label: 'Hogar y espacios',
      bg: '#DCA3A3',
      fg: BLACK_BRAND
    },
    'alimentos-y-bebidas': {
      label: 'Alimentos y bebidas',
      bg: '#EFB278',
      fg: BLACK_BRAND
    },
    'skincare-para-el-y-ella': {
      label: 'Skincare para él y ella',
      bg: '#D0D181',
      fg: BLACK_BRAND
    },
    'bienestar-emocional': {
      label: 'Bienestar emocional',
      bg: '#7FBDA6',
      fg: BLACK_BRAND
    }
  };

  var APRENDER_QUERY =
    'query AprenderArticles($handle: String!, $first: Int!) {\n' +
    '  blog(handle: $handle) {\n' +
    '    handle\n' +
    '    onlineStoreUrl\n' +
    '    articles(first: $first, sortKey: PUBLISHED_AT, reverse: true) {\n' +
    '      nodes {\n' +
    '        id\n' +
    '        title\n' +
    '        handle\n' +
    '        onlineStoreUrl\n' +
    '        image { url altText }\n' +
    '        aprender: metafield(namespace: "custom", key: "aprender") { value }\n' +
    '        imagenCard: metafield(namespace: "custom", key: "imagen_card_aprender") {\n' +
    '          reference {\n' +
    '            __typename\n' +
    '            ... on MediaImage { image { url altText } }\n' +
    '            ... on GenericFile { url previewImage { url } }\n' +
    '          }\n' +
    '        }\n' +
    '        categoriaAprender: metafield(namespace: "custom", key: "categorias_aprender") { value }\n' +
    '      }\n' +
    '    }\n' +
    '  }\n' +
    '}';

  function escapeHtml(text) {
    if (text == null) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function isMetafieldTrue(metafield) {
    if (!metafield) return false;
    var v = metafield.value;
    if (v === true || v === 1) return true;
    if (typeof v === 'string') {
      var s = v.trim().toLowerCase();
      return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
  }

  function hasGraphqlErrors(body) {
    return !!(body && body.errors && body.errors.length > 0);
  }

  function normalizeCategoryKey(raw) {
    if (!raw) return '';
    return String(raw)
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function categoryRawFromMetafield(mf) {
    if (!mf) return '';
    if (mf.reference) {
      var ref = mf.reference;
      if (ref.titulo && ref.titulo.value) return ref.titulo.value;
      if (ref.handle) return ref.handle;
    }
    if (!mf.value) return '';
    var raw = mf.value;
    if (typeof raw === 'string') {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed[0];
      } catch (e) {
        /* valor plano */
      }
    }
    return raw;
  }

  var CATEGORY_ORDER = [
    'bienestar-corporal',
    'hogar-y-espacios',
    'alimentos-y-bebidas',
    'skincare-para-el-y-ella',
    'bienestar-emocional'
  ];

  function categoryKeyFromMetafield(mf) {
    var raw = categoryRawFromMetafield(mf);
    if (!raw) return '';
    var key = normalizeCategoryKey(raw);
    if (CATEGORIA_APRENDER[key]) return key;
    var aliases = {
      'bienestar-corporal': ['bienestar', 'corporal'],
      'hogar-y-espacios': ['hogar', 'espacios'],
      'alimentos-y-bebidas': ['alimentos', 'bebidas'],
      'skincare-para-el-y-ella': ['skincare', 'el-y-ella', 'para-el'],
      'bienestar-emocional': ['emocional']
    };
    for (var i = 0; i < CATEGORY_ORDER.length; i++) {
      var k = CATEGORY_ORDER[i];
      if (key.indexOf(k) !== -1) return k;
      var parts = aliases[k] || [];
      var match = parts.length > 0;
      for (var j = 0; j < parts.length; j++) {
        if (key.indexOf(parts[j]) === -1) match = false;
      }
      if (match) return k;
    }
    return '';
  }

  function pickLatestPerCategory(articles, limit) {
    var picked = [];
    var used = {};
    for (var ci = 0; ci < CATEGORY_ORDER.length; ci++) {
      if (picked.length >= limit) break;
      var target = CATEGORY_ORDER[ci];
      for (var ai = 0; ai < articles.length; ai++) {
        var article = articles[ai];
        var catKey = categoryKeyFromMetafield(article.categoriaAprender);
        if (catKey !== target || used[article.id]) continue;
        picked.push(article);
        used[article.id] = true;
        break;
      }
    }
    return picked;
  }

  function collectionHandleToCategory(handle) {
    if (!handle) return '';
    var h = normalizeCategoryKey(handle);
    if (CATEGORIA_APRENDER[h]) return h;
    for (var i = 0; i < CATEGORY_ORDER.length; i++) {
      if (h.indexOf(CATEGORY_ORDER[i]) !== -1) return CATEGORY_ORDER[i];
    }
    var aliases = {
      'bienestar-corporal': ['bienestar', 'corporal'],
      'hogar-y-espacios': ['hogar', 'espacios'],
      'alimentos-y-bebidas': ['alimentos', 'bebidas'],
      'skincare-para-el-y-ella': ['skincare', 'el-y-ella', 'para-el'],
      'bienestar-emocional': ['emocional']
    };
    for (var j = 0; j < CATEGORY_ORDER.length; j++) {
      var key = CATEGORY_ORDER[j];
      var parts = aliases[key] || [];
      var match = parts.length > 0;
      for (var k = 0; k < parts.length; k++) {
        if (h.indexOf(parts[k]) === -1) match = false;
      }
      if (match) return key;
    }
    return '';
  }

  function pickFromCategory(articles, catKey, limit, used) {
    var picked = [];
    used = used || {};
    for (var i = 0; i < articles.length; i++) {
      if (picked.length >= limit) break;
      var article = articles[i];
      if (used[article.id]) continue;
      var key = categoryKeyFromMetafield(article.categoriaAprender);
      if (key !== catKey) continue;
      picked.push(article);
      used[article.id] = true;
    }
    return picked;
  }

  function tokenizeSearch(query) {
    return normalizeCategoryKey(query)
      .split('-')
      .filter(function (t) {
        return t.length > 2;
      });
  }

  function scoreArticleForSearch(article, query) {
    if (!query) return 0;
    var title = normalizeCategoryKey(article.title || '');
    var q = normalizeCategoryKey(query);
    if (!q) return 0;
    if (title.indexOf(q) !== -1) return 10;
    var tokens = tokenizeSearch(query);
    if (!tokens.length) return 0;
    var score = 0;
    for (var i = 0; i < tokens.length; i++) {
      if (title.indexOf(tokens[i]) !== -1) score += 3;
    }
    var catKey = categoryKeyFromMetafield(article.categoriaAprender);
    if (catKey && q.indexOf(catKey.replace(/-/g, ' ')) !== -1) score += 2;
    return score;
  }

  function pickBySearch(articles, query, limit) {
    var scored = [];
    for (var i = 0; i < articles.length; i++) {
      var s = scoreArticleForSearch(articles[i], query);
      if (s > 0) scored.push({ article: articles[i], score: s });
    }
    scored.sort(function (a, b) {
      return b.score - a.score;
    });
    var picked = [];
    for (var j = 0; j < scored.length && picked.length < limit; j++) {
      picked.push(scored[j].article);
    }
    return picked;
  }

  function pickForContext(articles, options) {
    var limit = options.limit || 5;
    var mode = options.mode || 'auto';
    if (mode === 'all') return pickLatestPerCategory(articles, limit);

    var used = {};
    var picked = [];
    var searchQuery = (options.searchQuery || '').trim();
    var contextCategory = (options.contextCategory || '').trim();
    var contextHandle = (options.contextHandle || '').trim();

    if (mode === 'manual' && contextCategory) {
      picked = pickFromCategory(articles, normalizeCategoryKey(contextCategory), limit, used);
      if (picked.length) return picked;
      return pickLatestPerCategory(articles, limit);
    }

    if (searchQuery.length > 2) {
      picked = pickBySearch(articles, searchQuery, limit);
      if (picked.length) return picked;
    }

    var catKey = contextCategory ? normalizeCategoryKey(contextCategory) : collectionHandleToCategory(contextHandle);
    if (catKey && CATEGORIA_APRENDER[catKey]) {
      picked = pickFromCategory(articles, catKey, limit, used);
      if (picked.length < limit) {
        var rest = pickLatestPerCategory(
          articles.filter(function (a) {
            return !used[a.id];
          }),
          limit - picked.length
        );
        picked = picked.concat(rest);
      }
      if (picked.length) return picked;
    }

    return pickLatestPerCategory(articles, limit);
  }

  function badgeFromCategoria(mf) {
    var key = categoryKeyFromMetafield(mf);
    if (key && CATEGORIA_APRENDER[key]) return CATEGORIA_APRENDER[key];
    return null;
  }

  function imageFromMetafield(mf) {
    if (!mf || !mf.reference) return null;
    var r = mf.reference;
    if (r.image && r.image.url) {
      return { url: r.image.url, alt: r.image.altText || '' };
    }
    if (r.previewImage && r.previewImage.url) {
      return { url: r.previewImage.url, alt: '' };
    }
    if (r.url) return { url: r.url, alt: '' };
    return null;
  }

  function articleUrl(article, blogHandle, shopDomain) {
    if (article.onlineStoreUrl) return article.onlineStoreUrl;
    if (article.handle && blogHandle) return '/blogs/' + encodeURIComponent(blogHandle) + '/' + encodeURIComponent(article.handle);
    return '#';
  }

  function renderCard(article, blogHandle, shopDomain, analyticsPrefix) {
    var prefix = (analyticsPrefix || 'aprender').trim();
    var articleHandle = (article.handle || '').trim() || 'articulo';
    var eventName = prefix + '_aprender_card_' + articleHandle;
    var badge = badgeFromCategoria(article.categoriaAprender);
    var labelText = badge ? badge.label : '';
    var labelBg = badge ? badge.bg : '';
    var labelFg = badge ? badge.fg : BLACK_BRAND;

    var cardImage = imageFromMetafield(article.imagenCard);
    if (!cardImage && article.image && article.image.url) {
      cardImage = { url: article.image.url, alt: article.image.altText || article.title || '' };
    }

    var href = articleUrl(article, blogHandle, shopDomain);
    var caption = article.title || '';
    var alt = (cardImage && cardImage.alt) || caption;

    var labelHtml = '';
    if (labelText) {
      labelHtml =
        '<span class="oleum-aprender__label" style="background-color:' +
        escapeHtml(labelBg) +
        ';color:' +
        escapeHtml(labelFg) +
        ';">' +
        escapeHtml(labelText) +
        '</span>';
    }

    var mediaHtml;
    if (cardImage && cardImage.url) {
      mediaHtml =
        '<img class="oleum-aprender__media" src="' +
        escapeHtml(cardImage.url) +
        '" alt="' +
        escapeHtml(alt) +
        '" loading="lazy" decoding="async" width="252" height="432">';
    } else {
      mediaHtml = '<div class="oleum-aprender__media oleum-aprender__media--placeholder" aria-hidden="true"></div>';
    }

    var captionHtml = caption
      ? '<p class="oleum-aprender__caption">' + escapeHtml(caption) + '</p>'
      : '';

    return (
      '<a class="oleum-aprender__card" href="' +
      escapeHtml(href) +
      '" role="listitem" data-eventoclick="' +
      escapeHtml(eventName) +
      '" data-ga-destination="' +
      escapeHtml(href) +
      '" data-ga-cta-type="aprender_card">' +
      '<div class="oleum-aprender__media-stage">' +
      labelHtml +
      '<div class="oleum-aprender__media-wrap">' +
      mediaHtml +
      '</div></div>' +
      captionHtml +
      '</a>'
    );
  }

  function insertCards(track, html) {
    clearStatus(track);
    track.insertAdjacentHTML('beforeend', html);
    refreshCarousel(track);
  }

  function refreshCarousel(track) {
    if (!track) return;
    var root = track.closest('[data-oleum-aprender-root]');
    if (root && window.OleumAprenderCarousel && window.OleumAprenderCarousel.refresh) {
      window.OleumAprenderCarousel.refresh(root);
    }
  }

  function clearStatus(track) {
    if (!track) return;
    track.querySelectorAll('.oleum-aprender__loading, .oleum-aprender__empty, .oleum-aprender__error').forEach(function (el) {
      el.remove();
    });
  }

  function useLiquidFallback(track) {
    if (!track || track.getAttribute('data-has-fallback') !== '1') return false;
    var sectionEl = track.closest('.section-oleum-home-aprender');
    if (!sectionEl) return false;
    var tpl = sectionEl.querySelector('[data-oleum-aprender-fallback]');
    if (!tpl || !tpl.content || !tpl.content.childNodes.length) return false;
    clearStatus(track);
    track.appendChild(tpl.content.cloneNode(true));
    refreshCarousel(track);
    return true;
  }

  function run(track) {
    var shopDomain = (track.getAttribute('data-shop-domain') || '').trim().replace(/^https?:\/\//i, '').split('/')[0];
    var token = (track.getAttribute('data-storefront-token') || '').trim();
    var blogHandle = (track.getAttribute('data-blog-handle') || 'aprender').trim();
    var limit = parseInt(track.getAttribute('data-articles-to-show'), 10) || 5;
    var emptyMessage = (track.getAttribute('data-empty-message') || '').trim();
    var contextMode = (track.getAttribute('data-context-mode') || 'auto').trim();
    var contextHandle = (track.getAttribute('data-context-handle') || '').trim();
    var contextCategory = (track.getAttribute('data-context-category') || '').trim();
    var searchQuery = (track.getAttribute('data-search-query') || '').trim();

    if (!contextHandle) {
      var pageHub = document.querySelector('[data-oleum-page-category-grid]');
      if (pageHub) {
        contextHandle = (pageHub.getAttribute('data-collection-handle') || '').trim();
      }
    }
    if (!contextCategory && contextHandle) {
      contextCategory = collectionHandleToCategory(contextHandle);
    }
    var explorarLink = document.getElementById('OleumAprenderExplorar-' + track.getAttribute('data-section-id'));

    function showError(msg) {
      if (useLiquidFallback(track)) return;
      clearStatus(track);
      track.insertAdjacentHTML(
        'beforeend',
        '<div class="oleum-aprender__error" role="status">' + escapeHtml(msg || 'No se pudieron cargar los artículos.') + '</div>'
      );
    }

    if (!shopDomain || !token) {
      showError(!token ? 'Falta el token de Storefront API en los ajustes de la sección.' : 'No se pudo obtener el dominio de la tienda.');
      return;
    }

    var apiUrl = 'https://' + shopDomain + '/api/2024-07/graphql.json';

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: APRENDER_QUERY,
        variables: { handle: blogHandle, first: 250 }
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || !data || hasGraphqlErrors(data)) {
          var errMsg = 'Error al cargar. Revisa el token y que el blog exista.';
          if (result.status === 401) {
            errMsg = 'Token Storefront inválido o expirado (401).';
          } else if (data && data.errors && data.errors[0]) {
            errMsg = data.errors[0].message || errMsg;
            if (data.errors[0].extensions && data.errors[0].extensions.code === 'UNAUTHORIZED') {
              errMsg = 'Token Storefront inválido o expirado.';
            }
          }
          showError(errMsg);
          return;
        }

        var blog = data.data && data.data.blog;
        if (!blog) {
          showError('No se encontró el blog «' + blogHandle + '».');
          return;
        }

        if (explorarLink && blog.onlineStoreUrl) {
          explorarLink.href = blog.onlineStoreUrl;
        }

        var nodes = (blog.articles && blog.articles.nodes) || [];
        var flagged = [];
        var excludeHandle = (track.getAttribute('data-exclude-article-handle') || '').trim();
        for (var i = 0; i < nodes.length; i++) {
          if (excludeHandle && nodes[i].handle === excludeHandle) continue;
          if (isMetafieldTrue(nodes[i].aprender)) {
            flagged.push(nodes[i]);
          }
        }
        var articles = pickForContext(flagged, {
          limit: limit,
          mode: contextMode,
          contextHandle: contextHandle,
          contextCategory: contextCategory,
          searchQuery: searchQuery
        });

        if (!articles.length) {
          if (useLiquidFallback(track)) return;
          clearStatus(track);
          track.insertAdjacentHTML(
            'beforeend',
            '<div class="oleum-aprender__empty" role="status">' +
              escapeHtml(emptyMessage || 'Aún no hay artículos marcados con custom.aprender = verdadero.') +
              '</div>'
          );
          return;
        }

        var analyticsPrefix = (track.getAttribute('data-ga-analytics-prefix') || 'aprender').trim();
        var html = '';
        for (var j = 0; j < articles.length; j++) {
          html += renderCard(articles[j], blogHandle, shopDomain, analyticsPrefix);
        }
        insertCards(track, html);
      })
      .catch(function () {
        if (useLiquidFallback(track)) return;
        showError('Error de conexión al cargar los artículos.');
      });
  }

  function init() {
    document.querySelectorAll('[data-oleum-aprender-api]:not([data-oleum-aprender-init])').forEach(function (el) {
      el.setAttribute('data-oleum-aprender-init', '1');
      run(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
